import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {lastValueFrom} from 'rxjs';
import {NextPimField} from 'app/Model/Catalog/NextPimField';
import {TemplateItem} from 'app/Model/Catalog/TemplateItem';
import {TemplateItemTemplate} from '../../Model/Catalog/TemplateItemTemplate';
import {TemplateService} from 'app/Services/template.service';
import {TemplateFieldsService} from '../../Services/templateFields.service';
import {LoginService} from '../../Services/login.service';
import {comparePimFields, fillLastKey, isNextPimField, parsePimField} from 'app/Services/templateItemHelpers';
import {ValueChangedEvent as NumberBoxValueChangeEvent} from 'devextreme/ui/number_box';
import {fieldNames} from 'app/Model/FieldNames';

@Component({
  selector: 'np-advanced-template-texts',
  templateUrl: './advanced-template-texts.component.html',
  standalone: false
})
export class AdvancedTemplateTextsComponent implements OnInit {
  @Input() templateItem!: TemplateItem;
  @Input() pimField!: NextPimField;
  @Input() fieldList: TemplateItemTemplate[] = [];
  @Output() onUpdate = new EventEmitter<void>();

  private static readonly FIELDS_WITH_SEQUENCE = [fieldNames.benefits, fieldNames.topFeatures];

  get needsSequenceNumber(): boolean {
    if (!this.pimField.field) return false;
    return AdvancedTemplateTextsComponent.FIELDS_WITH_SEQUENCE.includes(this.pimField.field);
  }

  constructor(
    private templateService: TemplateService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.pimField.systemKey = '-1';
    if (!this.needsSequenceNumber) {
      this.pimField.elementKey = '-1';
    }
  }

  getFieldDisplayExpr(item: TemplateItemTemplate) {
    return item?.text === item?.field ? item?.field ?? '' : `${item.text} (${item.field})`;
  }

  onFieldChanged() {
    if (this.needsSequenceNumber) {
      this.normalizeElementKey(parseInt(this.pimField.elementKey));
    } else {
      this.pimField.elementKey = '-1';
    }
    this.update();
  }

  onOrderChanged(event: NumberBoxValueChangeEvent) {
    this.normalizeElementKey(event.value);
    this.update();
  }

  async update() {
    const {field, systemKey = '-1', elementKey = '-1'} = this.pimField;
    const parsedKey = parsePimField(this.templateItem.key, systemKey, elementKey);
    if (parsedKey !== null && (comparePimFields(parsedKey, this.pimField) || !isNextPimField(parsedKey.field))) {
      this.onUpdate.emit();
      return;
    }

    let headline = await lastValueFrom(
      this.templateService.getHeadline(field, elementKey, systemKey, this.loginService.currentCustomer.id)
    );
    fillLastKey(this.templateItem, headline.value);
    this.onUpdate.emit();
  }

  private normalizeElementKey(value: number) {
    if (isNaN(value) || value <= 0) {
      this.pimField.elementKey = '1';
    } else {
      this.pimField.elementKey = value.toString();
    }
  }

  protected readonly parseInt = parseInt;
}
